export default "__VITE_ASSET__D8jsQsc7__"